import { FrontendApplication, FrontendApplicationContribution, WidgetManager } from '@theia/core/lib/browser';
import { Widget } from '@theia/core/lib/browser/widgets/widget';
import { inject, injectable } from '@theia/core/shared/inversify';
import { LaunchScreenHostWidget } from './launch-screen-host-widget';

@injectable()
export class LaunchScreenHostContribution implements FrontendApplicationContribution {
    @inject(WidgetManager)
    protected readonly widgetManager!: WidgetManager;

    async onStart(_app: FrontendApplication): Promise<void> {
        const widget: LaunchScreenHostWidget = await this.widgetManager.getOrCreateWidget(LaunchScreenHostWidget.ID);
        if (!widget.isAttached) Widget.attach(widget, document.body);
    }
}
